// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".contract-detail-dialog[data-v-c154f492] .el-dialog{width:var(--common-dialog-medium-width)}.contract-detail-dialog .el-form[data-v-c154f492]{margin-right:var(--common-dialog-form-margin-right)}", ""]);
// Exports
module.exports = exports;
